import { CFormCheck } from '@coreui/react-pro'
import React from 'react'
import './LTCToggleBox.scss'

export default function LTCToggleBox({
  onToggleChange,
  isToggledOn,
  padding = false,
  hasPccOverride,
}) {
  return (
    <div className={`toggleBox ${padding ? 'padding' : ''}`}>
      <div className="care-label">
        Care Type
        {hasPccOverride && (
          <i
            title={
              'When available from PCC, Care Type is automatically entered. Please review for accuracy.'
            }
            className="fa-regular fa-circle-info"
            style={{ color: 'var(--default-text-color)', marginLeft: '4px' }}
          ></i>
        )}
      </div>
      <div>
        <CFormCheck
          button={{ color: 'primary', variant: 'outline', size: 'sm', shape: 'rounded' }}
          type="radio"
          id="skilled"
          label="Skilled"
          checked={!isToggledOn}
          onChange={() => onToggleChange(false)}
        />
        <CFormCheck
          button={{ color: 'primary', variant: 'outline', size: 'sm', shape: 'rounded' }}
          type="radio"
          id="longterm"
          label="Long-term"
          checked={isToggledOn}
          onChange={() => onToggleChange(true)}
        />
      </div>
    </div>
  )
}
